export default {
    vCardLink: (state, value) => {
        state.vCardLink = value
    },
    isVCardShowing: (state, value) => {
        state.isVCardShowing = value
    }
}
  